export default [
  {
    path: "/article",
    name: "Article",
    component: () => import(/* webpackChunkName: "Article" */ "@/views/article"),
    meta: {
      spm: "b17801" /** data-spm-desc: 文章 **/,
      title: "文章",
      isLogin: true,
    },
  },
  {
    path: "/brochure",
    name: "Brochure",
    component: () => import(/* webpackChunkName: "Brochure" */ "@/views/brochure"),
    meta: {
      spm: "b17802" /** data-spm-desc: 宣传册 **/,
      title: "宣传册",
      isLogin: true,
    },
  },
  {
    path: "/form",
    name: "Form",
    component: () => import(/* webpackChunkName: "Form" */ "@/views/form"),
    meta: {
      spm: "b17803" /** data-spm-desc: 表单 **/,
      title: "表单",
      isLogin: true,
    },
  },
  {
    path: "/h5",
    name: "H5",
    component: () => import(/* webpackChunkName: "H5" */ "@/views/h5"),
    meta: {
      spm: "b17804" /** data-spm-desc: H5 **/,
      title: "H5",
      isLogin: true,
    },
  },
  {
    path: "/link",
    name: "Link",
    component: () => import(/* webpackChunkName: "Link" */ "@/views/link"),
    meta: {
      spm: "b17805" /** data-spm-desc: 任意链接 **/,
      title: "任意链接",
      isLogin: true,
    },
  },
  {
    path: "/mk-video",
    name: "MkVideo",
    component: () => import(/* webpackChunkName: "MkVideo" */ "@/views/mk-video"),
    meta: {
      spm: "b17806" /** data-spm-desc: 视频 **/,
      title: "视频",
      isLogin: true,
    },
  },
  {
    path: "/video",
    name: "Video",
    component: () => import(/* webpackChunkName: "Video" */ "@/views/video"),
    meta: {
      spm: "b17807" /** data-spm-desc: 普通视频 **/,
      title: "普通视频",
    },
  },
  {
    path: "/poster",
    name: "Poster",
    component: () => import(/* webpackChunkName: "Poster" */ "@/views/poster"),
    meta: {
      spm: "b17808" /** data-spm-desc: 海报 **/,
      title: "海报",
      isLogin: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "Poster" */ "@/views/login"),
    meta: {
      spm: "b17811" /** data-spm-desc: 登录 **/,
      title: "登录",
    },
  },
  {
    path: "/music",
    name: "Music",
    component: () => import(/* webpackChunkName: "Poster" */ "@/views/music-player"),
    meta: {
      spm: "b17809" /** data-spm-desc: 音频 **/,
      title: "音频",
    },
  },
  {
    path: "/link-me",
    name: "LinkMe",
    component: () => import(/* webpackChunkName: "Poster" */ "@/views/link-me"),
    meta: {
      spm: "b17810" /** data-spm-desc: 联系我 **/,
      title: "联系我",
    },
  },
  {
    path: "/ordinary-file",
    name: "OrdinaryFile",
    component: () => import(/* webpackChunkName: "OrdinaryFile" */ "@/views/ordinary-file"),
    meta: {
      spm: "b17812" /** data-spm-desc: 文件 **/,
      title: "文件",
    },
  },
  {
    path: "/activities-landing-page",
    name: "ActivitiesLandingPage",
    component: () =>
      import(/* webpackChunkName: "ActivitiesLandingPage" */ "@/views/activities/landing-page"),
    meta: {
      spm: "b17813" /** data-spm-desc: 活动落地页 **/,
      title: "活动",
      isLogin: true,
    },
  },
  {
    path: "/activities-sign-in",
    name: "ActivitiesSignIn",
    component: () =>
      import(/* webpackChunkName: "ActivitiesSignIn" */ "@/views/activities/sign-in"),
    meta: {
      spm: "b17814" /** data-spm-desc: 活动签到 **/,
      title: "签到",
      isLogin: true,
    },
  },
  {
    path: "/tools",
    name: "Tools",
    component: () => import(/* webpackChunkName: "Tools" */ "@/views/tools"),
    meta: {
      spm: "b17815" /** data-spm-desc: 工具 **/,
      title: "系统工具",
      isLogin: true,
    },
  },
  {
    path: "/pdf",
    name: "PDF",
    component: () => import(/* webpackChunkName: "PDF" */ "@/views/pdf"),
    meta: {
      // spm: "b17808" /** data-spm-desc: 海报 **/,
      title: "PDF"
    },
  },
];
